import { FORM_COMPONENT_TYPES } from './constants'
import { getIn } from 'final-form'
import { IFocusableInput } from './interface'

export const findInput = (inputs: IFocusableInput[], errors: object): IFocusableInput | undefined =>
  inputs.find((input: IFocusableInput) => {
    const name = input.name || input.id
    return name && getIn(errors, name)
  })

export const getComponentByType = (type: string) => FORM_COMPONENT_TYPES[type]

export const getLabelType = (type: string) => (type === 'checkbox' || type === 'toggle' ? 'inline' : 'placeholder')
